<div class="container mx-auto px-4">
  <div class="sticky z-40 bg-white pb-3" style="top: 64px;">
    <div class="mb-6">
      <h1 class="text-3xl font-bold text-gray-800 mb-2">
        Consolidated Income Report
      </h1>
      <p class="text-gray-600">
        Period totals across every revenue category (includes archived client
        records). Choose a month, year, or a custom range, then click Search to
        refresh the dashboard.
      </p>
    </div>

    <!-- Filters -->
    <search class="lg:w-full mt-4" tuiSearch style="padding-left: 0">
      <fieldset class="flex items-center gap-4 border-none flex-wrap">
        <div class="w-[180px]">
          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="rangeFilterControl"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let type of rangeFilterTypes" [value]="type">
              {{ type }}
            </option>
          </select>
        </div>

        <div class="flex gap-2" *ngIf="rangeFilterControl.value === 'Monthly'">
          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="monthControl"
            class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let month of months" [value]="month.value">
              {{ month.label }}
            </option>
          </select>

          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="yearControl"
            class="w-[100px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
          </select>
        </div>

        <div class="flex gap-2" *ngIf="rangeFilterControl.value === 'Annually'">
          <select [formControl]="yearControl"
            class="w-[120px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
          </select>
        </div>

        <div class="min-w-[280px]" *ngIf="rangeFilterControl.value === 'Custom Range'">
          <tui-input-date-range [formControl]="customRangeControl">
            Choose date range
            <input placeholder="From - To" tuiTextfieldLegacy />
          </tui-input-date-range>
        </div>

        <button (click)="applyFilters()" appearance="secondary" size="m" tuiButton type="button"
          class="w-full sm:w-auto" style="border: 2px solid #e5e7ea; font-weight: 800">
          Search
        </button>

        <button appearance="flat" iconStart="@tui.rotate-cw" tuiButton type="reset" (click)="clearFilters()">
          Clear
        </button>
        <button tuiButton appearance="primary" size="m" (click)="exportToExcel()">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline mr-2" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Export to Excel
        </button>
      </fieldset>
    </search>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <tui-loader size="xl" [overlay]="true"></tui-loader>
  </div>

  <ng-container *ngIf="!loading && totals">
    <div class="bg-white rounded-lg shadow-md p-6 mt-6">
      <div class="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <h2 class="text-sm font-medium text-gray-500">Period</h2>
          <p class="text-xl font-semibold text-gray-800">{{ windowLabel || '—' }}</p>
        </div>
        <div class="text-right">
          <h2 class="text-sm font-medium text-gray-500">Grand Total</h2>
          <p class="text-3xl font-bold text-orange-600">
            LKR {{ totals.grandTotal | number : '1.2-2' }}
          </p>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
      <div *ngFor="let card of categoryCards" class="bg-white rounded-lg shadow-md p-5 flex flex-col gap-2"
        [ngClass]="card.accent">
        <div>
          <h3 class="text-base font-semibold text-gray-800">{{ card.label }}</h3>
          <p class="text-xs text-gray-500">{{ card.description }}</p>
        </div>
        <p class="text-2xl font-bold text-gray-900">
          LKR {{ card.total | number : '1.2-2' }}
        </p>
        <div *ngIf="
            (card.shiftCharges !== undefined && card.shiftCharges !== null) ||
            (card.additionalCharges !== undefined && card.additionalCharges !== null)
          " class="text-xs text-gray-600 flex flex-col gap-1">
          <span *ngIf="card.shiftCharges !== undefined">
            Shift charges:
            <span class="font-medium text-gray-800">
              LKR {{ card.shiftCharges | number : '1.2-2' }}
            </span>
          </span>
          <span *ngIf="card.additionalCharges !== undefined">
            Extra charges:
            <span class="font-medium text-gray-800">
              LKR {{ card.additionalCharges | number : '1.2-2' }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow-md mt-6 overflow-hidden">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Income Category
            </th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Amount (LKR)
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let card of categoryCards">
            <td class="px-6 py-3 text-sm text-gray-900">{{ card.label }}</td>
            <td class="px-6 py-3 text-sm text-right text-gray-900">
              LKR {{ card.total | number : '1.2-2' }}
            </td>
          </tr>
          <tr class="bg-blue-50 font-bold">
            <td class="px-6 py-4 text-sm text-gray-900">Grand Total</td>
            <td class="px-6 py-4 text-sm text-right text-blue-700">
              LKR {{ totals.grandTotal | number : '1.2-2' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div *ngIf="!loading && !totals" class="bg-white rounded-lg shadow-md p-8 mt-6 text-center text-gray-500">
    <p class="text-lg">No data to show yet</p>
    <p class="text-sm mt-2">
      Pick a period above and click Search to load consolidated income.
    </p>
  </div>
</div>